import { GSAPI_CALL_NAME } from "../../Csi/csi.types";

export class keepAlive{
    private keepAlivePingIntervalTime = (window as any).GENERAL_CONFIG.keepAlivePingInterval.time || 0;
    private keepAlivePingEndpoint = (window as any).GENERAL_CONFIG.keepAlivePingInterval.endpoint || "";
    private keepAlivePingUrl = (window as any).GENERAL_CONFIG.keepAlivePingInterval.url || "";
    private keepAliveType = (window as any).GENERAL_CONFIG.keepAlivePingInterval.type;
    private keepAlivePingEnvMap = (window as any).GENERAL_CONFIG.keepAlivePingInterval.envMap;
    private keepAlivePingEndpointLink = "";
    private keepAliveTimer: ReturnType<typeof setInterval> | null = null
    private ACTION_BALANCE = "V2/balance"

    constructor(private params: any, private transport: any){

    }
    
    private setKeepAlivePingEndpoint(): string {
        const source = this.params.location || window.location.href;
        let pingUrl = ""

        try{
            const url = new URL(source);
            
            switch(this.keepAliveType){
                case "local": {
                    if (!this.keepAlivePingUrl) return "";

                    const fakeUserToken = "test-user";
                    const fakeSessionToken = "test-session";

                    return this.keepAlivePingUrl
                        .replace("{action}", this.ACTION_BALANCE)
                        .replace("{user_token}", fakeUserToken)
                        .replace("{session_token}", fakeSessionToken);
                }
                case "worldmatch":{
                    if (!this.keepAlivePingUrl) return "";

                    const launching = url.searchParams.get("launching");
                    if (!launching) return "";

                    const launchingUrl = new URL(decodeURIComponent(launching));
                    const userToken = launchingUrl.searchParams.get("usertoken");
                    const sessionToken = launchingUrl.searchParams.get("sessiontoken");

                    if (!userToken || !sessionToken) return "";

                    return this.keepAlivePingUrl
                        .replace("{action}", this.ACTION_BALANCE)
                        .replace("{user_token}", userToken)
                        .replace("{session_token}", sessionToken);
                }

                case "microgame": {
                    const env = url.searchParams.get("env") || "prod";

                    let baseUrl = this.keepAlivePingEnvMap[env];

                    if(env === "develop"){
                        baseUrl = baseUrl.replace("{protocol}", window.location.protocol)
                        baseUrl = baseUrl.replace("{server}", window.location.hostname);
                    }

                    return baseUrl + (this.params?.session || "")

                }

                case "queryParam": {
                    return url.searchParams.get(this.keepAlivePingEndpoint) ?? ""
                }

                default: {
                    return "";
                }
            }

        } catch (e){
            console.error("error")
            return ""
        }
    }

    public keepAlivePingStart(){
        this.keepAlivePingEndpointLink = this.setKeepAlivePingEndpoint();

        if (!this.keepAlivePingEndpointLink || this.keepAlivePingIntervalTime <= 0) {
            return;
        }
        if(this.keepAliveTimer) return;

        this.keepAlivePingSend(); // Primo ping subito

        this.keepAliveTimer = setInterval(() => {
            this.keepAlivePingSend();
        }, this.keepAlivePingIntervalTime); 
    }
    
    public keepAlivePingSend(): void{
        if ((window as any).Game?.paused) return;
        if (!this.keepAlivePingEndpointLink) return;

        void this.transport.callSilent(GSAPI_CALL_NAME.GENERIC, this.keepAlivePingEndpointLink, null, 3000, "GET");
    }

    public keepAlivePingStop(): void {
        if (this.keepAliveTimer) {
            clearInterval(this.keepAliveTimer);
            this.keepAliveTimer = null;
        }
    }
}